import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); toast.success("If that email exists, a reset link is on its way."); }
    catch { toast.success("If that email exists, a reset link is on its way."); setSent(true); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] grain px-4">
      <div className="w-full max-w-md card-surface rounded-2xl p-8 gold-glow">
        <h1 className="font-display text-2xl text-center">Reset your password</h1>
        {sent ? (
          <p className="mt-4 text-white/60 text-sm text-center">Check your email for a reset link. It expires in 1 hour.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="email" required placeholder="Your admin email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg bg-black/50 border border-white/10 px-3 py-3 text-sm outline-none focus:border-[#D4AF37]" />
            <button className="w-full rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] py-3 font-semibold text-[#0A0A0A]">Send reset link</button>
          </form>
        )}
        <div className="text-center mt-6"><Link to="/admin/login" className="text-xs text-white/50 hover:text-[#D4AF37]">← Back to login</Link></div>
      </div>
    </div>
  );
}
